import { Routes } from '@angular/router';

export const subscriptionRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./subscriptions.page').then((m) => m.SubscriptionsPage),
  },
  {
    path: ':programId',
    loadComponent: () => import('./manage-subscription/manage-subscription.page').then((m) => m.ManageSubscriptionPage),
  },
  {
    path: ':programId/confirmation',
    loadComponent: () =>
      import('../../payment-subscription/payment-confirmation/payment-confirmation.component').then(
        (m) => m.PaymentConfirmationComponent,
      ),
    data: { canGoBack: true },
  },
  {
    path: ':programId/shipping-address',
    loadComponent: () =>
      import('./subscription-shipping-address/subscription-shipping-address.page').then(
        (m) => m.SubscriptionShippingAddressPage,
      ),
  },
  {
    path: ':programId/schedule-consultation',
    loadComponent: () =>
      import('@shared/pages/schedule-consultation/schedule-consultation.page').then((m) => m.ScheduleConsultationPage),
  },
  {
    path: ':programId/schedule-consultation/confirm',
    loadComponent: () =>
      import('@shared/pages/schedule-confirmation/schedule-confirmation.page').then((m) => m.ScheduleConfirmationPage),
  },
];
